import React, { useState, useRef, useEffect, Fragment } from "react";
import "./../components/Report.css";
import { _hasPermission } from "../../../../../../shared/helpers/access";
import { _axiosCall } from "../../../../../../shared/helpers/apicalls";
import moment from "moment";
import CustomLineChart from "./../components/CustomLineChart";
import UserProfile from "./../../components/UserProfile";
import Footer from "./../components/Footer";

import {
  _capitalizeText,
  _formatNumber,
  _formatPrice,
  _formatCurrency,
  _nameToUrl,
  _shouldShow,
  _getBuildingURL,
  buildingFL,
  _replaceAbbreviations,
  _formatBed,
  propertyFL,
  SalesProgress,
  _isEqual,
  _tranformTagsQuery,
  syncURLFilters,
  syncURLSearch,
  setURLFromState,
  setLocalStorage,
  getLocalStorage,
  deleteLocalStorage,
  syncStageFilters,
  mpndCohortQuery,
  syncGenericFilter,
  urlSlugBuilding,
  _isNewUser,
  _isEnterpriseUser,
  _objectEqual,
  getCohortQuery,
  _activityFQ,
  _isHouse,
  _formatBigPrice,
  houseBuildingCohortQuery,
  _activityFL,
} from "../../../../../../shared/helpers/utils";

import { formatDateRange, calculatePercentageChange, previousYearPeriod, generatePeriodNames, percentageChange, prepareResForAI, filterAIData, validateNestedData, getRangeEnd, getRangeStart, getCurrentPeriod, getPriorPeriod, openAIModel} from "../../../exportreport/utils";
import Stats from "./../components/Stats";
import CustomSkeleton from "../components/Skeleton";
import PropertyTypePage from "../components/PropertyTypePage";


const apiURL = process.env.API_ROOT;


let statTypes = [
  {
    key: "all",
    title: "Sales trends for $4M+ properties",
    name: "Luxury Sales",
    checkedColor: "#D5E1A3",
    activitesQuery: '(price:[4000000 TO *]) AND event_tags:(condo* co?op* coop* condo*p single?family)',
    default: true,
  },
  
];

const statFacet = {
  avg_price: "avg(price)",
  med_price: "percentile(price, 50)",
  sum_price: "sum(price)",
  ppsf: {
    type: "query",
    q: "sq_ft:[300 TO 20000]",
    facet: {
      avg: "avg(div(price, sq_ft))",
      med: "percentile(div(price, sq_ft), 50)",
    },
  },
  buildings : {
    type : "terms",
    field : "display_full_street_address",
    limit : 3,
    facet: {
      by_name: {
        type : "terms",
         field : "building_name",
      }
     
    },
  },
  dom: {
    type: "query",
    q: "days_on_market:[3 TO 720]",
    facet: {
      avg: "avg(days_on_market)",
      med: "percentile(days_on_market, 50)",
    },
  },
  under_one: {
    type: "query",
    q: "price:[10000 TO 999999]",
    facet: {
      avg_price: "avg(price)",
      med_price: "percentile(price, 50)",
      sum_price: "sum(price)",
      ppsf: {
        type: "query",
        q: "sq_ft:[300 TO 20000]",
        facet: {
          avg: "avg(div(price, sq_ft))",
          med: "percentile(div(price, sq_ft), 50)",
        },
      },
      dom: {
        type: "query",
        q: "days_on_market:[3 TO 720]",
        facet: {
          avg: "avg(days_on_market)",
          med: "percentile(days_on_market, 50)",
        },
      },
    },
  },
  one_to_two: {
    type: "query",
    q: "price:[1000000 TO 1999999]",
    facet: {
      avg_price: "avg(price)",
      med_price: "percentile(price, 50)",
      sum_price: "sum(price)",
      ppsf: {
        type: "query",
        q: "sq_ft:[300 TO 20000]",
        facet: {
          avg: "avg(div(price, sq_ft))",
          med: "percentile(div(price, sq_ft), 50)",
        },
      },
      dom: {
        type: "query",
        q: "days_on_market:[3 TO 720]",
        facet: {
          avg: "avg(days_on_market)",
          med: "percentile(days_on_market, 50)",
        },
      },
    },
  },
  two_to_four: {
    type: "query",
    q: "price:[2000000 TO 3999999]",
    facet: {
      avg_price: "avg(price)",
      med_price: "percentile(price, 50)",
      sum_price: "sum(price)",
      ppsf: {
        type: "query",
        q: "sq_ft:[300 TO 20000]",
        facet: {
          avg: "avg(div(price, sq_ft))",
          med: "percentile(div(price, sq_ft), 50)",
        },
      },
      dom: {
        type: "query",
        q: "days_on_market:[3 TO 720]",
        facet: {
          avg: "avg(days_on_market)",
          med: "percentile(days_on_market, 50)",
        },
      },
    },
  },
  four_to_ten: {
    type: "query",
    q: "price:[4000000 TO 9999999]",
    facet: {
      avg_price: "avg(price)",
      med_price: "percentile(price, 50)",
      sum_price: "sum(price)",
      ppsf: {
        type: "query",
        q: "sq_ft:[300 TO 20000]",
        facet: {
          avg: "avg(div(price, sq_ft))",
          med: "percentile(div(price, sq_ft), 50)",
        },
      },
      dom: {
        type: "query",
        q: "days_on_market:[3 TO 720]",
        facet: {
          avg: "avg(days_on_market)",
          med: "percentile(days_on_market, 50)",
        },
      },
    },
  },
  ten_plus: {
    type: "query",
    q: "price:[10000000 TO 350000000]",
    facet: {
      avg_price: "avg(price)",
      med_price: "percentile(price, 50)",
      sum_price: "sum(price)",
      ppsf: {
        type: "query",
        q: "sq_ft:[300 TO 20000]",
        facet: {
          avg: "avg(div(price, sq_ft))",
          med: "percentile(div(price, sq_ft), 50)",
        },
      },
      dom: {
        type: "query",
        q: "days_on_market:[3 TO 720]",
        facet: {
          avg: "avg(days_on_market)",
          med: "percentile(days_on_market, 50)",
        },
      },
    },
  }
};

const Layout = (props) => {
  const {
    fetchInProgress,
    setFetchInProgress,
    user,
    reportLoaded,
    setReportLoaded,
    reportData,
    setReportData,
    searchTags,
    summarizeGeographies,
    customDate,
    submit,
    setSubmit,
    color,
    logo,
    formValues,
    setAiResponse,
    AiResponse,
    setFetchAi,
    fetchAi,
    setAIInProgress,
    defaultLogo
  } = props;
  const { dateOptions, theme, branding } = customDate;
  const currentPeriod = getCurrentPeriod(dateOptions)
  const priorPeriod = getPriorPeriod(dateOptions)
  const priorYearPeriod = priorPeriod;

  const rangeEnd =getRangeEnd(dateOptions)
  const rangeStart = getRangeStart;;
  const gap = dateOptions.gap;
  const currentPeriodName = generatePeriodNames(dateOptions).currentPeriod;
  const priorPeriodName = generatePeriodNames(dateOptions).priorPeriod;
  const priorYearPeriodName = generatePeriodNames(dateOptions).priorYearPeriod;
  console.log(dateOptions, "helloChintan");
  useEffect(() => {
    if (!reportData && !fetchInProgress && submit) {
      loadData();
      setSubmit(false)
    }
  }, [submit]);
  useEffect(() => {
    console.log(reportData, fetchAi)
      const fetchAIData = async () => {
       setFetchAi &&  setFetchAi(false);
       setAIInProgress(true);
       

     let  aiData = prepareResForAI(JSON.parse(JSON.stringify(reportData.facets)));
         const aiResponse = await handleAIGenerate(aiData);
      
   
        setAiResponse &&  setAiResponse(aiResponse);
        setAIInProgress(false);
      };
    
      if ( reportData && fetchAi) {
        fetchAIData();
        
      }
    }, [reportData, fetchAi])
  const dataFacet = {
    contract_signed: {
      type: "query",
      q: "topic:listings AND event_tags:contract-signed AND -event_tags:rent AND -event_tags:*commercial*",
      facet: {
        current_period: {
          type: "query",
          q: `time:${currentPeriod}`,
          facet: statFacet,
        },
        prior_period: {
          type: "query",
          q: `time:${priorPeriod}`,
          facet: statFacet,
        },
        chart: {
          range: {
            field: "time",
            start: rangeStart,
            end: rangeEnd,
            gap: gap,
            facet: {
              dom: {
                type: "query",
                q: "days_on_market:[3 TO 720]",
                facet: {
                  avg: "avg(days_on_market)",
                  med: "percentile(days_on_market, 50)",
                },
              },
            },
          },
        },
      },
    },
   
  };

  const loadData = async () => {
    let q = "*:*";
    let locQuery = _tranformTagsQuery(searchTags);

    if (locQuery) {
      q = locQuery;
    }

    const defaultQ = getCohortQuery(user, true);
    const fq = [
        ..._activityFQ.slice(),
        ...[`{!join from=alternate_keys fromIndex=we3-buildings to=building}${defaultQ}`],
    ];
    setFetchInProgress(true);
    let facet = {};
    statTypes.map((item) => {
      facet[item.key] = {
        type: "query",
        q: item.activitesQuery,
        facet: dataFacet,
      };
    });
    let axiosData = {
      url: apiURL + "/query/we3-activities-3?cache_time=1440&always-cache=true",
      method: "post",
      query: {
        q: q,
        fq: fq,
        wt: "json",
        rows: 3,
        sort: "price desc",
        "json.facet": facet,
      },
    };

    let res = await _axiosCall(axiosData)
      .then(async (res) => {
        let aiData;
        if (res && res.facets) {
          // aiData = prepareResForAI(JSON.parse(JSON.stringify(res.facets)));
          // const aiResponse = await handleAIGenerate(aiData);
          // res["aiResponse"] = aiResponse;
          console.log(res)
          setFetchInProgress(false);
          setReportLoaded(true);
          setSubmit(false);
          setReportData(res);
          setFetchAi && setFetchAi(true)
        }
        return res;
      })
      .catch((error) => {
        console.log("error: " + error);
      });
  };
  const handleAIGenerate = async (data) => {
    const prompt = `Given the following data give me an analysis of contracts for ${currentPeriodName} for the luxury market. The analysis should be easy to understand for consumer audiences and no more than 2 sentences.  Focus on the count of contracts, ppdf, avg_prices, and days on market (dom), also look at buildings with the most contracts under buildings.  Also provide  analysis about low price vs high priced units, no more than 2 sentences.  Abbreviate long currency so it's $1.5M, round if less than $1M.  If less than $1M use K.  Number should be in format ###,###,###  The results should be in valid raw JSON format, no formatting.  { "contract_signed" : "analysis in text"}
    
    The geography focuses on ${summarizeGeographies(searchTags)}
    
    Current Period: ${currentPeriodName}
    Prior Year Period: ${priorYearPeriodName}
    
    Contains the following key stats:${JSON.stringify(filterAIData(data))}`;


    const queryData = {
      messages: [
        {
          role: "system",
          content: `You are a NYC real estate expert that provides insightly data-driven analysis that are easy to understand.  You speak in a professional yet friendly manner.  Think TV or news analysts.`,
        },
        { role: "user", content: prompt },
      ],
      model: openAIModel,
      response_format: { type: "json_object" },
    };

    const axiosData = {
      url: apiURL + "/ai/chat",
      method: "post",
      query: queryData,
    };
    let aiResponse = {};
    try {
      const res = await _axiosCall(axiosData);
      console.log(res);

      if (
        res &&
        res.choices &&
        res.choices[0] &&
        res.choices[0].message &&
        res.choices[0].message.content
      ) {
        const result = res.choices[0].message.content;
        //console.log(result);
        try {
          aiResponse = JSON.parse(result);
        } catch (e) {}
      }
    } catch (error) {
      console.log("Error generating summary:", error);
    }
    return aiResponse;
  };

  const percentageChange = (newValue, oldValue) => {
    const percentageChange = ((newValue - oldValue) / oldValue) * 100;
    const roundedChange = Math.round(percentageChange * 10) / 10;

    return roundedChange;
  };

  if (!reportData) return null;
  const InventoryData = [
    "12K Square foot 432 Park",
    "New Development 2Bedroom $25k",
    "UES 2 Bedroom $25K or $3.45M",
    "Tribaca TH- Fully Furnished",
  ];
  const PropertyTypePageBack = (props) => {
      const { name, title, type } = props;
      const hasLocation = searchTags && searchTags.length>0;
      const chartData =  validateNestedData(
        reportData,
        `facets.all.contract_signed.chart`
      )
        ? reportData.facets.all.contract_signed.chart.buckets.slice(reportData.facets.all.contract_signed.chart.buckets.length - 13, reportData.facets.all.contract_signed.chart.buckets.length).map(item => ({date : formatDateRange(null, null, item.val), val: item.count ? Math.round(item.count) : 0})) : [];
      return (
        <>
          <div className="news-letter-daily-deals-container page-section">
            <section className="news-header-wrapper">
              <div className="news-sub-heading-main">
                <section className="social-branding">
                  {branding && branding && branding === "mylogo" && logo ? (
                    <div className="brand-logo">
                      <div>
                        <img
                          className="header-logo"
                          src={logo}
                          style={{ maxHeight: 70 }}
                        />
                      </div>
                    </div>
                  ) : branding && branding && branding === "marketproof" ? (
                    <div className="brand-logo">
                      <div>
                        <img
                          src={defaultLogo}
                          style={{ maxHeight: 70 }}
                        />
                      </div>
                    </div>
                  ) : null}
                  <UserProfile formValues={formValues} user={user} />
                </section>
              
              </div>
              <h3 className="header-text heading-location editable">{searchTags && searchTags.length>0 ? _capitalizeText(summarizeGeographies(searchTags)) : "New York City"}</h3>
              <div className="heading editable">{type.name}</div>
              
              <div className="sub-header-wrapper">
               <div className="sub-header-type editable">{type.title}</div>
               <div className="sub-header-type date editable">{currentPeriodName}</div>
              </div>
            </section>
            <section className="content-news-section">
              
              <section className="flex-section">
                <div className="left-side-flex">
                  <div className="img-outer-container">
                    
                   <div className="summary-text editable">
                    {AiResponse && AiResponse.contract_signed? AiResponse.contract_signed: <CustomSkeleton count={20}/>}
                   </div>
                  </div>
                  <h2 className="section-main-heading right-side-sub-heading  editable">
                    Top Buildings
                  </h2>
                  <div className="inventory-container">
                   
                    {validateNestedData(
                      reportData,
                      `facets.all.contract_signed.current_period.buildings.buckets`
                    ) ?
                    <>
                      {reportData.facets.all.contract_signed.current_period.buildings.buckets.map((building, index) => {
                        return <div key={index}><strong>{building.by_name && building.by_name.buckets.length>0 && building.by_name.buckets.filter(d => d.val !="").length > 0 ? _capitalizeText(building.by_name.buckets.filter(d => d.val !="")[0].val) : _capitalizeText(building.val)}</strong><br/>{building.count} Contracts</div>;
                      })} 
                     </>: null
                  }
                  </div>
                </div>
                <div className="right-side-flex">
                  <div className="total-sub-market">
                    <h2 className="section-main-heading  editable">Contracts</h2>
                    <Stats
                      data={[
                        { name: "Contracts", value: (validateNestedData(
                          reportData,
                          `facets.all.contract_signed.current_period.count`
                        ) ? _formatNumber(
                              reportData.facets.all.contract_signed.current_period.count
                            )
                          : "--") },
                        
                        { name: "Avg Price", value: (validateNestedData(
                          reportData,
                          `facets.all.contract_signed.current_period.avg_price`
                        ) 
                          ? `${_formatPrice(
                              reportData.facets.all.contract_signed.current_period
                                .avg_price)}`
                          : "--") },
                        { name: "Avg PPF", value: (validateNestedData(
                          reportData,
                          `facets.all.contract_signed.current_period.ppsf.avg`
                        )  ? `$${_formatNumber(
                              reportData.facets.all.contract_signed.current_period
                                .ppsf.avg)}`
                          : "--") },
                       
                        { name: "DOM", value: (validateNestedData(
                          reportData,
                          `facets.all.contract_signed.current_period.dom.avg`
                        ) 
                          ? `${_formatNumber(
                              reportData.facets.all.contract_signed.current_period
                                .dom.avg)}` : "--") },
                      ]}
                    />
                  </div>
                  <div class="contract-activity">
                    <CustomLineChart
                      data={chartData}
                      theme={theme}
                      isWeekly={dateOptions.gap}
                    />
                   
                    <div className="stat-line">
                    <h3>$4M to $10M</h3>
                    <Stats
                      data={[
                        { name: "Contracts", value: (validateNestedData(
                          reportData,
                          `facets.all.contract_signed.current_period.four_to_ten.count`
                        ) ? _formatNumber(
                              reportData.facets.all.contract_signed.current_period.four_to_ten.count
                            )
                          : "--") },
                        
                        { name: "Avg Price", value: (validateNestedData(
                          reportData,
                          `facets.all.contract_signed.current_period.four_to_ten.avg_price`
                        ) 
                          ? `${_formatPrice(
                              reportData.facets.all.contract_signed.current_period.four_to_ten
                                .avg_price)}`
                          : "--") },
                        { name: "Avg PPF", value: (validateNestedData(
                          reportData,
                          `facets.all.contract_signed.current_period.four_to_ten.ppsf.avg`
                        )  ? `$${_formatNumber(
                              reportData.facets.all.contract_signed.current_period.four_to_ten
                                .ppsf.avg)}`
                          : "--") },
                       
                        { name: "DOM", value: (validateNestedData(
                          reportData,
                          `facets.all.contract_signed.current_period.four_to_ten.dom.avg`
                        ) 
                          ? `${_formatNumber(
                              reportData.facets.all.contract_signed.current_period.four_to_ten
                                .dom.avg)}` : "--") },
                      ]}
                    />
                    </div>
                    <div className="stat-line">
                    <h3>More than $10M</h3>
                    <Stats
                      data={[
                        { name: "Contracts", value: (validateNestedData(
                          reportData,
                          `facets.all.contract_signed.current_period.ten_plus.count`
                        ) ? _formatNumber(
                              reportData.facets.all.contract_signed.current_period.ten_plus.count
                            )
                          : "--") },
                        
                        { name: "Avg Price", value: (validateNestedData(
                          reportData,
                          `facets.all.contract_signed.current_period.ten_plus.avg_price`
                        ) 
                          ? `${_formatPrice(
                              reportData.facets.all.contract_signed.current_period.ten_plus
                                .avg_price)}`
                          : "--") },
                        { name: "Avg PPF", value: (validateNestedData(
                          reportData,
                          `facets.all.contract_signed.current_period.ten_plus.ppsf.avg`
                        )  ? `$${_formatNumber(
                              reportData.facets.all.contract_signed.current_period.ten_plus
                                .ppsf.avg)}`
                          : "--") },
                       
                        { name: "DOM", value: (validateNestedData(
                          reportData,
                          `facets.all.contract_signed.current_period.ten_plus.dom.avg`
                        ) 
                          ? `${_formatNumber(
                              reportData.facets.all.contract_signed.current_period.ten_plus
                                .dom.avg)}` : "--") },
                      ]}
                    />
                    </div>
                    
                  </div>
                </div>
                
              
              </section>
            </section>
            <Footer />
          </div>
        </>
      );
  }
  if (!reportData) return null;
  return (
    <>
    {statTypes.map(type => {
      
      return <PropertyTypePage type={type} 
      {...props}
      isLux={true}
      summarizeGeographies={summarizeGeographies} 
      priorYearPeriodName={priorYearPeriodName} 
      currentPeriodName={currentPeriodName}/>
      
    })}
    </>
  )
};

export default Layout;
